import { render, staticRenderFns } from "./video_info.vue?vue&type=template&id=1fe46fb9&scoped=true"
import script from "./video_info.vue?vue&type=script&lang=js"
export * from "./video_info.vue?vue&type=script&lang=js"
import style0 from "./video_info.vue?vue&type=style&index=0&id=1fe46fb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe46fb9",
  null
  
)

export default component.exports